/**
 * Utility functions for parsing participant identity
 * Handles the pattern: "Name Surname|email@domain.com"
 */

/**
 * Parse participant identity into name and email components
 * @param {string} identity - The identity string (e.g., "Mario Rossi|mario@email.com" or "Mario Rossi")
 * @returns {object} - Object with name and email properties
 */
export function parseIdentity(identity) {
	if (!identity) {
		return { name: '', email: null }
	}

	const parts = identity.split('|')
	return {
		name: parts[0] || '',
		email: parts[1] || null
	}
}

/**
 * Create identity string from name and optional email
 * @param {string} name - The participant name
 * @param {string} email - The participant email (optional)
 * @returns {string} - The formatted identity string
 */
export function createIdentity(name, email) {
	if (!name) {
		return ''
	}

	let identity = name.trim()
	if (email && email.trim()) {
		identity += '|' + email.trim()
	}

	return identity
}

/**
 * Extract just the name part from an identity
 * @param {string} identity - The identity string
 * @returns {string} - Just the name part
 */
export function getNameFromIdentity(identity) {
	return parseIdentity(identity).name
}

/**
 * Extract just the email part from an identity
 * @param {string} identity - The identity string
 * @returns {string|null} - Just the email part, or null if not present
 */
export function getEmailFromIdentity(identity) {
	return parseIdentity(identity).email
}

/**
 * Check if an identity contains an email
 * @param {string} identity - The identity string
 * @returns {boolean} - True if email is present
 */
export function hasEmail(identity) {
	return getEmailFromIdentity(identity) !== null
}
